import firebase from "firebase/compat/app";
import { getFirestore } from "firebase/firestore";

const app = firebase.initializeApp({
	apiKey: "AIzaSyCJmdajQhLPladeQzKrO8JnXFRCmJUO-G8",
	authDomain: "tvm-app-d3196.firebaseapp.com",
	projectId: "tvm-app-d3196",
	storageBucket: "tvm-app-d3196.appspot.com",
	messagingSenderId: "467895392589",
	appId: "1:467895392589:web:b2b8d4111e13414c423f04",
	measurementId: "G-BXQ96EZ60B",
});

export const firestoreDb = getFirestore(app);
